import * as React from 'react';
import { IAdvantagesItemProps } from './content';
import { ArticleHeading4, UIHeading2, UIText1 } from '@cian/ui-kit';

import * as styles from './styles.css';

export const AdvantagesItem: React.FC<IAdvantagesItemProps> = ({ iconUrl, title, description, onClick }) => {
  return (
    <div className={styles['item']}>
      <div className={styles['heading']}>
        <img src={iconUrl} alt={description} />

        <UIHeading2 color="black_100">{title}</UIHeading2>
      </div>

      <div>
        <UIText1>{description}</UIText1>
      </div>

      {onClick && (
        <div className={styles['action']} onClick={onClick}>
          <ArticleHeading4 color="text-main-default">Подробнее</ArticleHeading4>
        </div>
      )}
    </div>
  );
};
